import axios from 'axios';
import {
	ACCESS_TOKEN,
	API_URL,
} from './Variables';
import VueCookie from "vue-cookie";
let client = (baseUrl = null, additionalHeaders = {}) => {
	let accessToken = ACCESS_TOKEN;
	if (ACCESS_TOKEN == null) {
		accessToken = '';
	}

	let defaultHeaders = {
		'X-Requested-With': 'XMLHttpRequest',
		'Accept': 'application/json',
		'Authorization': 'Bearer ' + accessToken
	};

	let axiosOptions = {
		baseURL: baseUrl,
		headers: {
			...defaultHeaders,
			...additionalHeaders
		},
	};

	let instance = axios.create(axiosOptions);
	instance.interceptors.request.use((config) => {
		config.headers['X-Socket-ID'] = window.Echo.socketId();
		return config
	});
	return instance;
};

class ApiClientFactory {
	constructor(baseUrl = null) {
		if (baseUrl == null) {
			baseUrl = API_URL;
		}

		this.baseUrl = baseUrl;
	}

	get(url, requestData = {}, headers = {}) {
		return client(this.baseUrl, headers).get(url, requestData);
	}

	post(url, requestData = {}, headers = {}) {
		return client(this.baseUrl, headers).post(url, requestData);
	}

	put(url, requestData = {}, headers = {}) {
		return client(this.baseUrl, headers).put(url, requestData);
	}

	delete(url, requestData = {}, headers = {}) {
		return client(this.baseUrl, headers).delete(url, requestData);
	}
}

export {
	ApiClientFactory
};